export default "__VITE_ASSET__JwPdj2pL__"